import React, { useEffect, useState } from 'react';

const HealthCheck = () => {
  const [latency, setLatency] = useState(null);

  useEffect(() => {
    const start = performance.now();
    setLatency(0); // ensure render

    // Optional: simulate ping to backend or just frontend-only check
    const end = performance.now();
    setLatency(Math.round(end - start));
  }, []);

  return (
    <div className="h-screen flex items-center justify-center bg-green-800 text-center p-4">
      <div>
        <h1 className="text-2xl font-bold text-green-200">Frontend Health: OK</h1>
        <p className="mt-2 text-gray-200">Timestamp: {new Date().toISOString()}</p>
        <p className="text-gray-200">Render Latency: {latency} ms</p>
      </div>
    </div>
  );
};

export default HealthCheck;
